import axios from "axios";

const api = axios.create({
  baseURL: "https://api.sicamobile.com/api/atm/auth/", // Base API URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  console.log("Token:", token);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or unauthorized
      localStorage.removeItem("adminToken");
      window.location.href = "/sign-in";
    }
    return Promise.reject(error);
  }
);

export default api;
